'use strict';
import util from '../../util';
import shipping from './shipping';




/**
 * @function
 * @description Selects the first address from the list of addresses
 */
export default {
    init : function () {
    const $form = $('.address');

    // select address from list
    $('select[name$="_addressList"]', $form).on('selectmenuchange change', function () {
        const selected = $(this).children(':selected').first();
        const selectedAddress = $(selected).data('address');
        if (!selectedAddress) {
            return;
        }
        util.fillAddressFields(selectedAddress, $form);
        shipping.updateShippingMethodList();
        // re-validate the form
        $form.validate().form();
    });
	
    }
};
